<div class="flex h-full flex-col items-center justify-center text-[var(--neutral-50)] dark:text-[var(--neutral-70)]">
  <div
    class="mb-4 flex items-center justify-center rounded-full bg-[var(--neutral-90)] p-6 dark:bg-[var(--neutral-17)]">
    <mat-icon class="scale-150">chat</mat-icon>
  </div>
  <p class="text-lg text-center font-medium">{{ 'yardOperations.details.messages.noMessages' | translate }}</p>
</div>
